import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MCalibrationItemPartComponent } from './calibration-item-part.component';
import { MCalibrationItemComponent } from './calibration-item.component';
import { MCalibrationComponent } from './calibration.component';

@NgModule({
  imports: [CommonModule],
  declarations: [MCalibrationItemComponent, MCalibrationComponent, MCalibrationItemPartComponent],
  exports: [MCalibrationItemComponent, MCalibrationComponent, MCalibrationItemPartComponent]
})
export class MCalibrationModule {}
